import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";

export default function Blogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/blogs").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="container-page py-16 max-w-4xl" data-testid="blogs-page">
      <h1 className="font-display text-5xl tracking-tight border-b border-border pb-4 mb-12">From the press</h1>
      {items.length === 0 ? (
        <div className="text-sm text-muted-foreground italic">No posts yet.</div>
      ) : (
        <div className="space-y-10">
          {items.map((b) => (
            <article key={b.id} data-testid={`blog-${b.slug}`} className="border-b border-border pb-8 last:border-0">
              <div className="text-xs text-muted-foreground uppercase tracking-[0.18em]">{b.created_at?.slice(0, 10)}</div>
              <h2 className="font-display text-3xl tracking-tight mt-2"><Link to={`/blog/${b.slug}`} className="hover:text-accent">{b.title}</Link></h2>
              <p className="text-base text-muted-foreground mt-3 leading-relaxed italic">{b.excerpt}</p>
              <Link to={`/blog/${b.slug}`} className="inline-block mt-3 text-sm font-medium hover:text-accent uppercase tracking-wide">Read on →</Link>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
